export default __webpack_public_path__ + "static/media/Months_12.522ee11d.png";